import AsyncComponent from '../hoc/asyncComponent/asyncComponent';
import { Route, Switch } from 'react-router-dom';
import React from 'react';

// Components
import ResetPassword from '../containers/Auth/ResetPassword/SubmitOtp/SubmitOtp';
import RedirectPage from "../containers/Auth/RedirectPage/redirect";

const asyncLogin = AsyncComponent(() => {
    return import('../containers/Auth/Login/Login')
});
const asyncNotFound = AsyncComponent(() => {
    return import('../containers/Auth/NOTFoundPage/notfoundpage')
})

const PublicRoutes = ({ match }) => (
    <Switch>
        <Route path='/' exact component={asyncLogin} />
        <Route path='/login' exact component={asyncLogin} />
        <Route path='/reset_password' exact component={ResetPassword} />
        <Route path='/notFound' exact component={asyncNotFound} />
	{/* <Route path='*' exact component={RedirectPage} /> */}
    </Switch>
);

export default PublicRoutes;
